<template>
    <div class="modal-content">
        <form novalidate @submit.prevent="recoveryPassword">
            <ErrorMessage
                v-if="errorMessage"
                :error-message="errorMessage"
            />

            <p class="modal-text">
                Введите Email, который вы использовали при регистрации.
                На данный Email мы вышлем новый пароль.
            </p>

            <div class="form-group">
                <Input
                    type="email"
                    placeholder="Ваш email*"
                    v-model.trim="email"
                    :invalid="$v.email.$error"
                    @keydown.space.prevent
                />

                <div
                    v-if="$v.email.$dirty && !$v.email.required"
                    class="invalid-feedback"
                >
                    Поле обязательно для заполнения
                </div>

                <div
                    v-else-if="$v.email.$dirty && !$v.email.email"
                    class="invalid-feedback"
                >
                    Некорректный E-mail
                </div>
            </div>

            <Button
                class="button"
                variant="gradient"
                type="submit"
                :disabled="isEmptyEmail || isRequesting"
                :title="isEmptyEmail ? 'Заполните обязательные поля' : ''"
            >
                Восстановить пароль
            </Button>
        </form>
    </div>
</template>
<script>
import { email, required } from 'vuelidate/lib/validators'
import ErrorMessage from "@/components/common/ErrorMessage"
import api from "../../application"
import CheckEmailModal from "@/components/common/SuccessModal"
import { SuccessModalProperties } from "@/utils/modalsProperties"
import Input from "@/components/homePage/Input"
import Button from "@/components/homePage/Button"

export default {
    name: "RestorePasswordModal",

    components: {
        ErrorMessage,
        Input,
        Button,
    },

    data() {
        return {
            email: null,
            errorMessage: null,
            isRequesting: false,
        }
    },

    computed: {
        isEmptyEmail() {
            return !this.email
        },
    },

    validations: {
        email: { required, email },
    },

    methods: {
        openSuccessModal() {
            this.$modal.show(
                CheckEmailModal,
                {
                    text:
                        'Новый пароль был отправлен на ваш E-mail. ' +
                        'Пожалуйста, используйте его для входа в систему.',
                },
                SuccessModalProperties
            )
        },

        async recoveryPassword() {
            if (this.$v.$invalid) {
                this.$v.$touch()
                return
            }

            this.isRequesting = true

            try {
                await api.auth.recoveryPassword({ email: this.email })
                this.openSuccessModal()
                this.email = null
            } catch (e) {
                this.errorMessage = e.response.data.errorMessage
            } finally {
                this.isRequesting = false
            }
        },
    },
}
</script>
<style lang="less" scoped>
    @import '../../assets/less/variables.less';

    .modal-content {
        form {
            display: flex;
            flex-direction: column;
            gap: 25px;
            .button {
                height: 60px;
                font-family: Montserrat;
                font-weight: 600;
                font-size: 24px;
                line-height: 1;
                width: 100%;
            }
        }
    }

    .modal-text {
        color: white;
        max-width: 230px;
        text-align: center;
        margin: 0 auto;
    }

    .form-group {
        margin: 0;
    }
</style>